import React, { useEffect, useState } from 'react';

import { getPublicSiteSettings } from '../services/siteContentService';

import { brandLogo } from '../config/brandAssets';

import './ReligiousTicker.css';



const DEFAULT_HADITH =

  'قال رسول الله ﷺ: « كافل اليتيم — له، أو لغيره — أنا وهو كهاتين في الجنة. » وأشار بالسبابة والوسطى.';



const DEFAULT_VERSE =

  'قال تعالى: « لَن تَنَالُوا الْبِرَّ حَتَّىٰ تُنفِقُوا مِمَّا تُحِبُّونَ ۚ وَمَا تُنفِقُوا مِن شَيْءٍ فَإِنَّ اللَّهَ بِهِ عَلِيمٌ » (3 آل عمران)';



const parsePipeItems = (value) =>

  (value || '')

    .split('|')

    .map((s) => s.trim())

    .filter(Boolean);



const ReligiousTicker = () => {

  const [items, setItems] = useState([

    { text: DEFAULT_HADITH, type: 'hadith' },

    { text: DEFAULT_VERSE, type: 'verse' },

  ]);



  useEffect(() => {

    getPublicSiteSettings()

      .then((settings) => {

        const hadith = settings?.ticker_hadith?.trim() || DEFAULT_HADITH;

        const verse = settings?.ticker_verse?.trim() || DEFAULT_VERSE;

        const extra = parsePipeItems(settings?.religious_ticker);



        const next = [

          { text: hadith, type: 'hadith' },

          { text: verse, type: 'verse' },

          ...extra.map((text) => ({ text, type: 'hadith' })),

        ];



        setItems(next);

      })

      .catch(() => {});

  }, []);



  const track = [...items, ...items];



  return (

    <div className="religious-ticker" dir="rtl" aria-label="أحاديث وآيات">

      <div className="religious-ticker__track-wrap">

        <div className="religious-ticker__track">

          {track.map((item, index) => (

            <span key={index} className="religious-ticker__item">

              <img src={brandLogo} alt="" className="religious-ticker__logo" />

              <span className={`religious-ticker__${item.type}`}>{item.text}</span>

              <span className="religious-ticker__dot" aria-hidden="true" />

            </span>

          ))}

        </div>

      </div>

    </div>

  );

};



export default ReligiousTicker;

